/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Gender/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Gender({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/ViewDetails/Content/Details/Gender"
  
}) {
let editRelationFromPersonRecordGenderValueData = fromData.useDataFormat({ viewPath,
context: 'edit_relation',
path: 'from_person_record.gender',
format: fromFormat.capitalize,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Gender.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Gender"
 weight="semibold"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 data="edit_relation.from_person_record.gender"
 format="/Data/format.js capitalize"
 text={editRelationFromPersonRecordGenderValueData}
/>
</div>
{children}
</React.Fragment>)
}